export const select2DocumentType = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}

export const select2Country = {
    placeholder: "",
    allowClear: true,
    width: 'auto',
    dropdownAutoWidth: true,
    minimumInputLength: 0,
    ajax: null
}